module.exports = __webpack_public_path__ + "static/media/thumbnail-egyedi-fa-acel-szerkezet-felujitas.4059342b.jpg";